export default {"src":"/_next/static/media/Bread 2.0a97d9d3.svg","height":57,"width":61,"blurWidth":0,"blurHeight":0};